import Title from "../components/ui/Title";
import { Link } from "react-router-dom";
import '../styles/pages/contest.scss'
import '../styles/pages/character.scss'

const Contest = () => {
    return (
        <div className="page-container">
            <Title text="Contest" size="full"/>

            <Link to='/contest/character-poll'>
                <div className="contest-banner">
                    <img src={`${process.env.PUBLIC_URL}/img/contest/character-poll_banner.webp`} alt="" />
                </div>
            </Link>
            <Link to='/contests'>
                <div className="contest-banner">
                    <img src={`${process.env.PUBLIC_URL}/img/contest/rcc.webp`} alt="" />
                </div>
            </Link>
        </div>
    )
}

export default Contest;